/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';
import { RangeControl, QueryControls } from '@wordpress/components';

/**
 * Inner dependencies.
 */
import Accordion from '../../../components/Accordion';
import blockInfo from '../constants';
const { hookPrefix, layouts } = blockInfo;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-content`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/content`,
	( content, props ) => {
		const { attributes, setAttributes, updateInnerBlocks } = props;
		const { layout, columns, query } = attributes;
		const {
			orderBy,
			order,
			selectedCategories,
			numberOfItems,
		} = query;
		const categorySuggestions = props.categories?.reduce(
			( accumulator, category ) => ( {
				...accumulator,
				[ category.name ]: category,
			} ),
			{}
		) ?? {};

		const suggestions = props.categories?.reduce(
			( accumulator, category ) => ( {
				...accumulator,
				[ category.name ]: category,
			} ),
			{}
		);
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<Accordion tabs={ [
					{
						name: 'posts',
						initialOpen: true,
						label: () => {
							return __( 'Posts' );
						},
						cb: () => {
							return <>
								{ layouts && <div className="gutenify-template-browser">
									<h2>Templates</h2>

									<ul>
										{ layouts.map( ( template ) => {
											let classnames = 'gutenify-template-browser-item';
											if ( layout === template.name ) {
												classnames += ' gutenify-template-browser-item-active';
											}
											return <li className={ classnames } key={ template.name }>
												<button className={ `gutenify-template-browser-selector` } onClick={ () => {
													const data = {
														layout: template.name,
														socialIconAlign: template.socialIconAlign,
														imageAlign: template.imageAlign,
														titleAlign: template.titleAlign,
													};
													setAttributes( data );
													updateInnerBlocks( template );
												} }>
													<img src={ `${ window.gutenify_block_data.plugin_directory_url }/assets/images/post-slider-layouts/${ template.name }.png` } alt={ template.name } />
													<small>{ template.label }</small>
												</button></li>;
										} ) }
									</ul>
								</div> }
								<QueryControls
									{ ...{ orderBy, order, numberOfItems } }
									onOrderByChange={ ( newOrderBy ) => setAttributes( {
										query: {
											...query,
											orderBy: newOrderBy,
										},
									} ) }
									onOrderChange={ ( newOrder ) => setAttributes( {
										query: {
											...query,
											order: newOrder,
										},
									} ) }
									categorySuggestions={ categorySuggestions }
									selectedCategories={ selectedCategories }
									onCategoryChange={ ( tokens ) => {
										const allCategories = tokens.map( ( token ) =>
											typeof token === 'string' ? suggestions[ token ] : token
										);
										setAttributes( {
											query: {
												...query,
												selectedCategories: allCategories,
											},
										} );
									} }
									onNumberOfItemsChange={ ( newNumberOfItems ) =>
										setAttributes( {
											query: {
												...query,
												numberOfItems: newNumberOfItems,
											},
										} )
									}
								/>
								<RangeControl value={ columns } label={ __( 'Columns' ) } min={ 1 } max={ 3 } step={ 1 } onChange={ ( value ) => {
									setAttributes( { columns: value } );
								} } />
							</>;
						},
					},
				] } />
			</Fragment>,
		];
	}
);
